<div class="media-browse-container">
  <div class="media-browse-header">
    <h1>Browse Media</h1>
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="media-nav">
      <a
        mat-tab-link
        *ngFor="let link of navLinks"
        [routerLink]="link.path"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive"
      >
        <mat-icon>{{ link.icon }}</mat-icon>
        {{ link.label }}
      </a>
    </nav>
  </div>

  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
